// Shared presentation categories; product records remain the source of product parameters.
export const CATALOG_CATEGORIES = [
  {
    title: "Sloupková mlžítka",
    eyebrow: "Jednotlivé body osvěžení",
    href: "/sloupkova-mlzitka",
    description:
      "Štíhlé nerezové prvky k pěším trasám, lavičkám a pobytovým plochám. Vyberte tvar, který přirozeně doplní architekturu místa.",
    image: "/media/categories/columns.webp",
    imageAlt: "Sloupková mlžítka LINEA v městském parku",
    use: "Parky · promenády · náměstí",
  },
  {
    title: "Mlžné brány a oblouky",
    eyebrow: "Osvěžení při průchodu",
    href: "/mlzne-brany",
    description:
      "Průchozí mlžné prvky pro vstupy, promenády a frekventovaná místa. Tvar a umístění volíme podle pohybu návštěvníků.",
    image:
      "/media/categories/gates.webp",
    imageAlt: "Mlžná brána GATE ve veřejném prostoru",
    use: "Vstupní zóny · sportoviště · areály",
  },
  {
    title: "Ateliérové a tvarové prvky",
    eyebrow: "Design s vlastním charakterem",
    href: "/atelierove-prvky",
    description:
      "Výrazné nerezové tvary pro místa setkávání a hravé venkovní prostory. Propojují vodní mlhu s osobitým výrazem instalace.",
    image:
      "/media/categories/sculptures.webp",
    imageAlt: "Tvarový mlžicí prvek MRAK",
    use: "Hřiště · školy · architektonické projekty",
  },
  {
    title: "Mlžiště a mlhoviště",
    eyebrow: "Celá zóna osvěžení",
    href: "/mlhoviste",
    description:
      "Promyšlené sestavy mlžítek, aleje a pobytové zóny. Rozmístění, přívod vody a volitelné řízení SUPLA navrhujeme jako jeden celek.",
    image: "/media/categories/zones.webp",
    imagePosition: "center 55%",
    imageAlt: "Mlžná zóna s prvky BENDY a LINEA v zahradě",
    use: "Náměstí · parky · rekreační areály",
  },
];
